"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const FormDto_1 = require("../dto/FormDto");
const FormField_1 = require("./FormField");
const EsText_1 = require("./EsText");
class Form {
    constructor(description, successSubmitText) {
        this.id = 0;
        this.state = FormDto_1.FormStateDto.DRAFT;
        this.type = FormDto_1.FormTypeDto.CUSTOM;
        this.title = "";
        this.shortDescription = "";
        this.fields = [];
        this.updated = 0;
        this.description = description;
        this.successSubmitText = successSubmitText;
    }
    static fromDto(dto) {
        const description = EsText_1.EsText.fromOptionalTextDto(dto.description);
        const successSubmitText = EsText_1.EsText.fromOptionalTextDto(dto.successSubmitText);
        const result = new Form(description, successSubmitText);
        result.id = dto.id;
        result.state = dto.state;
        result.type = dto.type;
        result.title = dto.title;
        if (dto.shortDescription) {
            result.shortDescription = dto.shortDescription;
        }
        result.fields = dto.fields ? dto.fields.map(fieldDto => FormField_1.FormField.fromDto(fieldDto)) : [];
        result.updated = dto.updated;
        return result;
    }
    toDto() {
        const dto = {
            id: this.id,
            state: this.state,
            type: this.type,
            title: this.title,
            fields: [],
            updated: this.updated
        };
        if (this.shortDescription) {
            dto.shortDescription = this.shortDescription;
        }
        if (this.description.notEmpty) {
            dto.description = this.description.toOptionalTextDto();
        }
        if (this.successSubmitText.notEmpty) {
            dto.successSubmitText = this.successSubmitText.toOptionalTextDto();
        }
        return dto;
    }
    equals(target) {
        return this.id === target.id
            && this.state === target.state
            && this.type === target.type
            && this.title === target.title
            && this.shortDescription === target.shortDescription
            && this.description.equals(target.description)
            && this.successSubmitText.equals(target.successSubmitText);
    }
    get fieldIds() {
        return this.fields.map(field => field.id);
    }
    fieldById(id) {
        return this.fields.find(field => field.id === id);
    }
    fieldsMap() {
        const result = {};
        this.fields.forEach(formField => result[String(formField.id)] = formField);
        return result;
    }
}
exports.Form = Form;
